export default {
    state: {
        steps: [
            {
                id: 1,
                name: 'Заявка',
                text: 'Оставляйте заявку на сайте и получите 2 варианта планировки квартиры БЕСПЛАТНО',
                src: require('~@/../../public/static/icons/mail.svg'),
            },
            {
                id: 2,
                name: 'Дизайн',
                text: 'Собираете на сайте стиль из четырех готовых решений с возможностью редактирования',
                src: require('~@/../../public/static/icons/design.svg'),
            },
            {
                id: 3,
                name: 'Расчет',
                text: 'Расчитываете финальную стоимость ремонта с помощью онлайн-калькулятора',
                src: require('~@/../../public/static/icons/calculate.svg'),
            },
            {
                id: 4,
                name: 'Договор',
                text: 'Собираете на сайте стиль из четырех готовых решений с возможностью редактирования',
                src: require('~@/../../public/static/icons/offer.svg'),
            },
            {
                id: 5,
                name: 'Ремонт',
                text: 'Собираете на сайте стиль из четырех готовых решений с возможностью редактирования',
                src: require('~@/../../public/static/icons/color.svg'),
            },
            {
                id: 6,
                name: 'Сдача объекта',
                text: 'Расчитываете финальную стоимость ремонта с помощью онлайн-калькулятора',
                src: require('~@/../../public/static/icons/home.svg'),
            },
        ]
    },
    mutations: {
    },
    actions: {
    },
    getters: {
        stepsList (state) {
            return state.steps
        }
    }
}
